import { FunctionComponent, useState } from 'react';
import styles from './Navbar.module.css';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { FiMenu, FiX } from 'react-icons/fi';

// import logo from "../../assets/logo.png";
// import svg from "../../assets/SVG.svg";
interface NavbarProps {
  onScrollToSection6: () => void;
}
const Navbar: FunctionComponent<NavbarProps> = ({ onScrollToSection6 }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const toggleMenu = () => setMenuOpen(!menuOpen);
  const handleGetInTouch = () => {
    window.location.href = '/contact-sales';
  };

  const handleSolutionsClick = () => {
    if (location.pathname === "/") {
      onScrollToSection6();
    } else {
      navigate("/", { replace: false });
  
      // Poll until #section6 is available in the DOM
      const scrollToSection = () => {
        const section = document.getElementById("section6");
        if (section) {
          // Use offset on desktop, scrollIntoView on mobile
          const isMobile = window.innerWidth <= 768;
  
          if (isMobile) {
            section.scrollIntoView({ behavior: "smooth" });
          } else {
            const yOffset = -580; // Adjust for fixed navbar
            const y = section.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({ top: y, behavior: "smooth" });
          }
        } else {
          requestAnimationFrame(scrollToSection); // Keep checking until section is mounted
        }
      };
  
      scrollToSection();
    }
  };
  

  const handleLogin = () => {
    window.open('https://web.credresolve.com/', '_blank', 'noopener,noreferrer');

  };
  return (
    <div className={styles.image127Parent} style={{ paddingTop: "20px" }}>

      <Link to="/">
        <img className={styles.image127Icon} alt="Logo" src="./assets/logo.png" />
      </Link>
      {/* Hamburger Menu for Mobile */}
      <div className={styles.menuIcon} onClick={toggleMenu} style={{ background: "none", border: "none", padding: 0 }}>
        {menuOpen ? FiX({ size: 24, color: "#3e1953" }) : FiMenu({ size: 24 })}
      </div>
      {menuOpen && (
        <div className={styles.navigationMobile} >

          <div onClick={() => { handleSolutionsClick(); setMenuOpen(false); }} style={{
            textDecoration: 'underline',
            textDecorationColor: 'white',
            marginTop:"10px",
            textUnderlineOffset: '4px', // 👈 adjust this value to your liking
            color: 'white'
          }}>
            <div className={styles.solutions} >Solutions</div>
          </div>

          <a
            href="/assets/resources.pdf"
            style={{
              textDecoration: 'underline',
              textDecorationColor: 'white',
              textUnderlineOffset: '4px', // 👈 adjust this value to your liking
              color: 'white'
            }}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => setMenuOpen(false)}
          >
            {/* <div className={styles.buttonMenu1}> */}
            <div className={styles.solutions}>Resources</div>
            {/* </div> */}
          </a>

          <Link
            to="/about-us"
            onClick={() => {
              setMenuOpen(false);
              window.scrollTo(0, 0);
            }}
            style={{ textDecoration: "none" }}
          >
            <div className={styles.solutions}>About Us</div>
          </Link>
        </div>

      )}

      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
        }}
      >
        <div className={styles.navigation}>
          <div className={styles.buttonMenu} onClick={handleSolutionsClick}>
            <div className={styles.solutions}>Solutions</div>
          </div>

          <a href="/assets/resources.pdf" style={{ textDecoration: 'none' }} target="_blank" rel="noopener noreferrer">
            <div className={styles.buttonMenu1} >
              <div className={styles.solutions} style={{ textDecoration: 'none' }}>Resources</div>
            </div>
          </a>


          <Link
            to="/about-us"
            onClick={() => window.scrollTo(0, 0)}
            style={{
              pointerEvents: 'auto',
              cursor: 'pointer',
              textDecoration: 'none',
            }}
          >
            <div className={styles.solutions}>About Us</div>
          </Link>


          {/* <div className={styles.solutions}>Contacts</div> */}
          {/* <div
            className={styles.solutions}
            onClick={() => {
              const footer = document.getElementById("footer-section");
              if (footer) {
                footer.scrollIntoView({ behavior: "smooth" });
              }
            }}
          >
            Contacts
          </div> */}

        </div>
      </div>

      <div
        className={styles.backgroundParent}
        style={{
          gap: '24px',
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
          flex: 1,
        }}
      >
        <div className={styles.background} onClick={handleGetInTouch} style={{ cursor: 'pointer' }}>
          <div className={styles.contactSales}>Get in touch</div>
        </div>
        <div className={styles.background1} onClick={handleLogin} style={{ cursor: 'pointer' }}>
          <div className={styles.login}>Log In</div>
        </div>
      </div>


    </div>
  );
};

export default Navbar;
